import { axiosInstance } from 'api/instance';
import { configEndpoints } from './config.endpoints';

const getConfigs = (customer, locationId) =>
  axiosInstance.get(configEndpoints.get_configs, {
    params: {
      location: locationId,
      customer: customer
    }
  });
const getConfigData = id => axiosInstance.get(configEndpoints.config_data(id));
const updateConfigData = (id, body) =>
  axiosInstance.post(configEndpoints.config_data(id), body);
export const configRequests = {
  getConfigs,
  getConfigData,
  updateConfigData
};
